// store/studentModeStore.js
// Modo de entrada del alumno (Portal del Alumno, F3): "vr" (gafas) o "screen"
// (movil/tablet/PC). Se PERSISTE en localStorage por dispositivo (a diferencia
// del grant del editor, que es por sesion): el alumno elige una vez y se
// recuerda. El modo condiciona el tema (claro vs oscuro/VR) y el layout.
//
// Persistencia manual con localStorage (sin middleware) para no depender de la
// version de zustand/persist. Autodeteccion de Quest solo como SUGERENCIA para
// preseleccionar en la pantalla S0; nunca fija el modo sin que el alumno confirme.
import { create } from "zustand";

const KEY = "edu-student-mode";

function loadMode() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "vr" || v === "screen" ? v : null;
  } catch (_e) {
    return null;
  }
}

function saveMode(mode) {
  try {
    if (mode) localStorage.setItem(KEY, mode);
    else localStorage.removeItem(KEY);
  } catch (_e) {
    /* almacenamiento no disponible: el modo vive solo en memoria */
  }
}

// Heuristica: navegador del visor (Meta Quest / Oculus Browser).
export function detectQuest() {
  if (typeof navigator === "undefined") return false;
  return /OculusBrowser|Quest/i.test(navigator.userAgent || "");
}

export const useStudentModeStore = create((set) => ({
  mode: loadMode(), // 'vr' | 'screen' | null
  setMode: (mode) => {
    saveMode(mode);
    set({ mode });
  },
  clearMode: () => {
    saveMode(null);
    set({ mode: null });
  },
}));
